// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import loginImage from '../../Assets/loginBG.png';
// import './LoginFirstSection.css';

// export default function LoginFirstSection() {

//     const navigator = useNavigate();

//     const navigate = useNavigate();
//     const [activeTab, setActiveTab] = useState('patient');

//     const handleForgetPass = (e) => {
//         e.preventDefault();
//         alert('Forgot Password is not ready yet!');
//     };

//     const handleForgetUsername = (e) => {
//         e.preventDefault();
//         alert('Forgot Username is not ready yet!');
//     };
//     const handleLogin = () => {
//         // Perform login logic here
//         // On successful login, navigate to dashboard
//         navigator('/dashboard');
//     }

//     return (
//         <div className="login-container">
//             <div className="login-illustration">
//                 <img src={loginImage} alt="Login illustration" />
//             </div>

//             <div className="login-form-box">
//                 <div className="login-tabs">
//                     <button
//                         className={`login-tab-btn ${activeTab === 'patient' ? 'active' : ''}`}
//                         onClick={() => setActiveTab('patient')}
//                     >
//                         Patient Register
//                     </button>
//                     <button
//                         className={`login-tab-btn ${activeTab === 'corporate' ? 'active' : ''}`}
//                         onClick={() => setActiveTab('corporate')}
//                     >
//                         Corporate Register
//                     </button>
//                 </div>

//                 <div className="registration-form-section">
//                     {activeTab === 'patient' ? (
//                         <>
//                             <h2>Patient Register</h2>
//                             <input type="text" placeholder="Mobile Number*" className="login-input"
//                             maxLength={10}
//                              />
//                             <input type="password" placeholder="Password*" className="login-input" />
//                             {/* <button className="login-btn rbdButton" onClick={() =>  navigator('/dashboard')}> */}

//                             <button className="login-btn rbdButton" onClick={() =>  handleLogin()}>
//                                 <span className="btn-text">Login</span>
//                             </button>
//                             <div className="login-footer">
//                                 <p>
//                                     Don't have an account?{' '}
//                                     <span className="login-link" onClick={() => navigate('/registration')}>
//                                         Register Now!
//                                     </span>
//                                 </p>
//                                 <p>
//                                     Forgot Password?{' '}
//                                     <span className="login-link" onClick={handleForgetPass}>
//                                         Click Here
//                                     </span>
//                                 </p>
//                             </div>
//                         </>
//                     ) : (
//                         <>
//                             <h2>Corporate Register</h2>
//                             <input type="text" placeholder="Username" className="login-input" />
//                             <input type="password" placeholder="Password" className="login-input" />
//                             <button className="login-btn rbdButton">
//                                 <span className="btn-text">Login</span>
//                             </button>
//                             <div className="login-footer">
//                                 <p>
//                                     Forgot Username?{' '}
//                                     <span className="login-link" onClick={handleForgetUsername}>
//                                         Click Here
//                                     </span>
//                                 </p>

//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// }

// import { useState, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa"; // 👈 for toggle icon
// import loginImage from "../../Assets/loginBG.png";
// import "./LoginFirstSection.css";
// import { userLogin } from "../../api/api";
// import { setUserData } from "../../utils/auth";
// import CustomLoader from "../../common/loader/CustomLoader";
// import toast from "react-hot-toast";

// export default function LoginFirstSection() {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("patient");
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     mobile: "",
//     password: "",
//   });
//    const [corporateFormData, setCorporateFormData] = useState({
//     Corporate_Username: "",
//     Corporate_Password: "",

//   })
  
//   const [showPassword, setShowPassword] = useState(false);
//   const passwordRef = useRef(null);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     try {
//       setLoading(true);

//       const payload = {
//         RBAuthKey: "RBDWAh!Q1s74e",
//         LoginType: "PT",
//         mobile_no: formData.mobile,
//         password: formData.password,
//         deviceid: "",
//       };

//       const response = await userLogin(payload);
//       console.log("Login response:", response);

//       if (response?.data?.status === "success") {
//         // ✅ Store user data using centralized helper
//         setUserData(response.data);
//         localStorage.setItem("userType", "patient");


//         console.log("Login successful:", response.data);

//         // ✅ Redirect to dashboard
//         navigate("/dashboard");
//       } else {
//         toast.error(response?.data?.message);
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       toast.error("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false); // ✅ reset loader state
//     }
//   };

//   const handleForgetPass = (e) => {
//     e.preventDefault();
//     navigate("/forget-password");
//   };

//   const handleForgetUsername = async (e) => {
//     e.preventDefault();
//   };

//   const isFormValid =
//     formData.mobile.trim() !== "" && formData.password.trim() !== "";

//     const CorporateHandleChange = (e) => {
//     setCorporateFormData({
//       ...corporateFormData,
//       [e.target.name]: e.target.value,
//     });
//   };

//     // Prefill corporate creds from localStorage (if present)
//     useEffect(() => {
//       try {
//         const raw = localStorage.getItem("rb_corp_creds");
//         if (raw) {
//           const parsed = JSON.parse(raw);
//           setCorporateFormData({
//             Corporate_Username: parsed?.mobile_no || "",
//             Corporate_Password: parsed?.password || "",
//           });
//         }
//       } catch (err) {
//         console.warn("Failed to read corporate creds from storage:", err);
//       }
//     }, []);

//   console.log("corporateFormData--->", corporateFormData);
//   console.log("form data ==>", formData);


//   const isCorporateFormValid =
//     corporateFormData.Corporate_Username.trim() !== "" && corporateFormData.Corporate_Password.trim() !== "";



//     const handleCorporateLogin = async (e) => {
//     e.preventDefault();

//     try {
//       setLoading(true);

//       const payload = {
//         RBAuthKey: "RBDWAh!Q1s74e",
//         LoginType: "CC",
//         mobile_no: corporateFormData.Corporate_Username,
//         password: corporateFormData.Corporate_Password,
//         deviceid: "",
//       };

//       const response = await userLogin(payload);
//       console.log("Login response:", response);

//       if (response?.data?.status === "success") {
//         // ✅ Store user data using centralized helper
//         setUserData(response.data);
//         localStorage.setItem("userType", "corporate");

//         // Persist corporate credentials to localStorage
//         try {
//           localStorage.setItem(
//             "rb_corp_creds",
//             JSON.stringify({ mobile_no: corporateFormData.Corporate_Username, password: corporateFormData.Corporate_Password })
//           );
//         } catch (err) {
//           console.warn("Could not save corporate credentials:", err);
//         }

//         console.log("Login successful:", response.data);

//         // ✅ Redirect to dashboard
//         navigate("/corporate");
//       } else {
//         alert(response?.data?.message || "Invalid mobile number or password.");
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setLoading(false); // ✅ reset loader state
//     }
//   };

//   return (
//     <div className="login-container">
//       {loading && <CustomLoader />}
//       <div className="login-illustration">
//         <img src={loginImage} alt="Login illustration" />
//       </div>

//       <div className="login-form-box">
//         <div className="login-tabs">
//           <button
//             className={`login-tab-btn ${
//               activeTab === "patient" ? "active" : ""
//             }`}
//             onClick={() => setActiveTab("patient")}
//           >
//             Patient Register
//           </button>
//           <button
//             className={`login-tab-btn ${
//               activeTab === "corporate" ? "active" : ""
//             }`}
//             onClick={() => setActiveTab("corporate")}
//           >
//             Corporate Register
//           </button>
//         </div>

//         <div className="registration-form-section">
//           {activeTab === "patient" ? (
//             <>
//               <h2>Patient Login</h2>

//               {/* Mobile Input */}
//               <div className="input-wrapper">
//                 <input
//                   type="tel"
//                   placeholder="Mobile Number*"
//                   className="custom-input"
//                   name="mobile"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                   maxLength={10}
//                   autoComplete="off"
//                   onCopy={(e) => e.preventDefault()}
//                   onPaste={(e) => e.preventDefault()}
//                   onCut={(e) => e.preventDefault()}
//                   onContextMenu={(e) => e.preventDefault()}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.keyCode === 13) {
//                       e.preventDefault();
//                       passwordRef.current?.focus();
//                     }
//                   }}
//                 />
//               </div>

//               {/* Password Input with Eye Toggle */}
//               <div className="input-wrapper">
//                 <input
//                   ref={passwordRef}
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Password*"
//                   className="custom-input"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   onCopy={(e) => e.preventDefault()}
//                   onPaste={(e) => e.preventDefault()}
//                   onCut={(e) => e.preventDefault()}
//                   onContextMenu={(e) => e.preventDefault()}
//                   autoComplete="off"
//                 />
//                 <span
//                   className="password-toggle-icon"
//                   onClick={() => setShowPassword((prev) => !prev)}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div>

//               {/* Login Button */}
//               <button
//                 className="login-btn rbdButton"
//                 onClick={handleLogin}
//                 disabled={!isFormValid || loading}
//                 style={{
//                   cursor: !isFormValid || loading ? "not-allowed" : "pointer",
//                   opacity: !isFormValid || loading ? 0.6 : 1,
//                 }}
//               >
//                 <span className="btn-text">
//                   {loading ? "Logging in..." : "Login"}
//                 </span>
//               </button>

//               {/* Footer */}
//               <div className="login-footer">
//                 <p>
//                   Don't have an account?{" "}
//                   <span
//                     className="login-link"
//                     onClick={() => navigate("/registration")}
//                   >
//                     Register Now!
//                   </span>
//                 </p>
//                 <p>
//                   Forgot Password?{" "}
//                   <span className="login-link" onClick={handleForgetPass}>
//                     Click Here
//                   </span>
//                 </p>
//               </div>
//             </>
//           ) : (
//             <>
//               <h2>Corporate Register</h2>
//               <input
//                 type="text"
//                 placeholder="Username"
//                 className="login-input"
//                 name="Corporate_Username"
//                 value={corporateFormData.Corporate_Username}
//                 onChange={CorporateHandleChange}
//                 maxLength={100}
//                 autoComplete="off"
//                 onCopy={(e) => e.preventDefault()}
//                 onPaste={(e) => e.preventDefault()}
//                 onCut={(e) => e.preventDefault()}
//                 onContextMenu={(e) => e.preventDefault()} //off to right click
//               />

//               {/* Corporate password with same wrapper + toggle as patient */}
//               <div className="password-wrapper">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Password"
//                   className="login-input"
//                   autoComplete="off"
//                   name="Corporate_Password"
//                   value={corporateFormData.Corporate_Password}
//                   onChange={CorporateHandleChange}
//                   onCopy={(e) => e.preventDefault()}
//                   onPaste={(e) => e.preventDefault()}
//                   onCut={(e) => e.preventDefault()}
//                   onContextMenu={(e) => e.preventDefault()}
//                 />
//                 <span
//                   className="password-toggle-icon"
//                   onClick={() => setShowPassword((prev) => !prev)}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div>

//               <button
//                 className="login-btn rbdButton"
//                 onClick={handleCorporateLogin}
//                 disabled={!isCorporateFormValid || loading}
//                 style={{
//                   cursor: isCorporateFormValid ? "pointer" : "not-allowed",
//                   opacity: isCorporateFormValid ? 1 : 0.6,
//                 }}
//               >
//                 <span className="btn-text">{loading ? "Logging in..." : "Login"}</span>
//               </button>
//               <div className="login-footer">
//                 <p>
//                   Forgot Username?{" "}
//                   <span className="login-link" onClick={handleForgetUsername}>
//                     Click Here
//                   </span>
//                 </p>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
// my upper code

// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import loginImage from '../../Assets/loginBG.png';
// import './LoginFirstSection.css';

// export default function LoginFirstSection() {

//     const navigator = useNavigate();

//     const navigate = useNavigate();
//     const [activeTab, setActiveTab] = useState('patient');

//     const handleForgetPass = (e) => {
//         e.preventDefault();
//         alert('Forgot Password is not ready yet!');
//     };

//     const handleForgetUsername = (e) => {
//         e.preventDefault();
//         alert('Forgot Username is not ready yet!');
//     };
//     const handleLogin = () => {
//         // Perform login logic here
//         // On successful login, navigate to dashboard
//         navigator('/dashboard');
//     }

//     return (
//         <div className="login-container">
//             <div className="login-illustration">
//                 <img src={loginImage} alt="Login illustration" />
//             </div>

//             <div className="login-form-box">
//                 <div className="login-tabs">
//                     <button
//                         className={`login-tab-btn ${activeTab === 'patient' ? 'active' : ''}`}
//                         onClick={() => setActiveTab('patient')}
//                     >
//                         Patient Register
//                     </button>
//                     <button
//                         className={`login-tab-btn ${activeTab === 'corporate' ? 'active' : ''}`}
//                         onClick={() => setActiveTab('corporate')}
//                     >
//                         Corporate Register
//                     </button>
//                 </div>

//                 <div className="registration-form-section">
//                     {activeTab === 'patient' ? (
//                         <>
//                             <h2>Patient Register</h2>
//                             <input type="text" placeholder="Mobile Number*" className="login-input"
//                             maxLength={10}
//                              />
//                             <input type="password" placeholder="Password*" className="login-input" />
//                             {/* <button className="login-btn rbdButton" onClick={() =>  navigator('/dashboard')}> */}

//                             <button className="login-btn rbdButton" onClick={() =>  handleLogin()}>
//                                 <span className="btn-text">Login</span>
//                             </button>
//                             <div className="login-footer">
//                                 <p>
//                                     Don't have an account?{' '}
//                                     <span className="login-link" onClick={() => navigate('/registration')}>
//                                         Register Now!
//                                     </span>
//                                 </p>
//                                 <p>
//                                     Forgot Password?{' '}
//                                     <span className="login-link" onClick={handleForgetPass}>
//                                         Click Here
//                                     </span>
//                                 </p>
//                             </div>
//                         </>
//                     ) : (
//                         <>
//                             <h2>Corporate Register</h2>
//                             <input type="text" placeholder="Username" className="login-input" />
//                             <input type="password" placeholder="Password" className="login-input" />
//                             <button className="login-btn rbdButton">
//                                 <span className="btn-text">Login</span>
//                             </button>
//                             <div className="login-footer">
//                                 <p>
//                                     Forgot Username?{' '}
//                                     <span className="login-link" onClick={handleForgetUsername}>
//                                         Click Here
//                                     </span>
//                                 </p>

//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// }

import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // 👈 for toggle icon
import loginImage from "../../Assets/loginBG.png";
import "./LoginFirstSection.css";
import { userLogin } from "../../api/api";
import { setUserData } from "../../utils/auth";
import CustomLoader from "../../common/loader/CustomLoader";
import toast from "react-hot-toast";

export default function LoginFirstSection() {
  //const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("patient");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
  });
   const [corporateFormData, setCorporateFormData] = useState({
    Corporate_Username: "",
    Corporate_Password: "",

  })
  
  const [showPassword, setShowPassword] = useState(false);
  const passwordRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        LoginType: "PT",
        mobile_no: formData.mobile,
        password: formData.password,
        deviceid: "",
      };

      const response = await userLogin(payload);
      console.log("Login response:", response);

      if (response?.data?.status === "success") {
        // ✅ Store user data using centralized helper
        setUserData(response.data);
        localStorage.setItem("userType", "patient");


        console.log("Login successful:", response.data);

        // ✅ Redirect to dashboard
        navigate("/dashboard");
      } else {
        toast.error(response?.data?.message);
      } 
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // ✅ reset loader state
    }
  };

  const handleForgetPass = (e) => {
    e.preventDefault();
    navigate("/forget-password");
  };

  const handleForgetUsername = async (e) => {
    e.preventDefault();
  };

  const isFormValid =
    formData.mobile.trim() !== "" && formData.password.trim() !== "";

    const CorporateHandleChange = (e) => {
    setCorporateFormData({
      ...corporateFormData,
      [e.target.name]: e.target.value,
    });
  };

    // Prefill corporate creds from localStorage (if present)
    useEffect(() => {
      try {
        const raw = localStorage.getItem("rb_corp_creds");
        if (raw) {
          const parsed = JSON.parse(raw);
          setCorporateFormData({
            Corporate_Username: parsed?.mobile_no || "",
            Corporate_Password: parsed?.password || "",
          });
        }
      } catch (err) {
        console.warn("Failed to read corporate creds from storage:", err);
      }
    }, []);

  console.log("corporateFormData--->", corporateFormData);
  console.log("form data ==>", formData);


  const isCorporateFormValid =
    corporateFormData.Corporate_Username.trim() !== "" && corporateFormData.Corporate_Password.trim() !== "";



    const handleCorporateLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        LoginType: "CC",
        mobile_no: corporateFormData.Corporate_Username,
        password: corporateFormData.Corporate_Password,
        deviceid: "",
      };

      const response = await userLogin(payload);
      console.log("Login response:", response);

      if (response?.data?.status === "success") {
        // ✅ Store user data using centralized helper
        setUserData(response.data);
        localStorage.setItem("userType", "corporate");

        // Persist corporate credentials to localStorage
        try {
          localStorage.setItem(
            "rb_corp_creds",
            JSON.stringify({ mobile_no: corporateFormData.Corporate_Username, password: corporateFormData.Corporate_Password })
          );
        } catch (err) {
          console.warn("Could not save corporate credentials:", err);
        }

        console.log("Login successful:", response.data);

        // ✅ Redirect to dashboard
        navigate("/corporate");
      } else {
        toast.error(response?.data?.message || "Invalid username or password.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // ✅ reset loader state
    }
  };


const navigate = useNavigate();
const handleGoAhead = () => {
  window.open("https://ori.rb-it.in:442/LogIn/DocLogIn", "_blank");
};


  return (
    <div className="login-container">
      {loading && <CustomLoader />}
      <div className="login-illustration">
        <img src={loginImage} alt="Login illustration" />
      </div>

      <div className="login-form-box">
        <div className="login-tabs">
          <button
            className={`login-tab-btn ${
              activeTab === "patient" ? "active" : ""
            }`}
            onClick={() => setActiveTab("patient")}
          >
            Patient
          </button>
          <button
            className={`login-tab-btn ${
              activeTab === "corporate" ? "active" : ""
            }`}
            onClick={() => setActiveTab("corporate")}
          >
            Corporate
          </button>
{/*<button
            className={`login-tab-btn ${
              activeTab === "OPD" ? "active" : ""
            }`}
            onClick={() => setActiveTab("opd")}
          >
            OPD Doctors
          </button>*/}

{/*<label>
          <input
            type="radio"
            name="role"
            value="opd"
            checked={activeTab === "opd"}
            onChange={(e) => setActiveTab(e.target.value)}
          />
          OPD Doctor
        </label>
      </div>

      {/* Go Ahead Button (only for OPD) *}
      {activeTab === "opd" && (
        <button
          className="goAheadBtn"
          onClick={() => navigate("/https://ori.rb-it.in:442/LogIn/DocLogIn")}
        >
          Go Ahead
        </button>
      )}*/}

         
{/*
 <label className={`roleBtn ${activeTab === "opd" ? "active" : ""}`}>
          <input type="radio" name="role" value="opd" checked={activeTab === "opd"} onChange={(e) => setActiveTab(e.target.value)}
          />
          OPD Doctor
        </label>
      </div>

      {activeTab === "opd" && (
        <button className="goAheadBtn" onClick={handleGoAhead}>
          Go Ahead
        </button>
      )}*/}


{/*working */}
       {/*<label className={`roleBtn ${activeTab === "opd" ? "active" : ""}`}>
          <input type="radio" name="role" value="opd" checked={activeTab === "opd"} onChange={(e) => setActiveTab(e.target.value)}
          />
          OPD Doctor
        </label>
      </div>

      {/* Show Go Ahead button only for OPD *}
      {activeTab === "opd" && (
        <button className="goAheadBtn" onClick={handleGoAhead}>
          Go Ahead
        </button>
      )}*/}


      <label
  className={`roleBtn ${activeTab === "opd" ? "active" : ""}`}
>
  <input
    type="radio"
    name="role"
    value="opd"
    checked={activeTab === "opd"}
    onChange={(e) => setActiveTab(e.target.value)}
  />
  OPD Doctor
</label>
</div>

{/* Content wrapper */}
<div className={`login-content ${activeTab === "opd" ? "center-opd" : ""}`}>
  {/* Show Go Ahead button only for OPD */}
  {activeTab === "opd" && (
    <button className="goAheadBtn" onClick={handleGoAhead}>
      Go Ahead
    </button>
  )}
</div>



    

        <div className="registration-form-section">
          {activeTab === "patient" ? (
            <>
              <h3>Patient Login</h3>

              {/* Mobile Input */}
              <div className="input-wrapper">
                <input
                  type="tel"
                  placeholder="Mobile Number*"
                  className="custom-input login-input-mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength={10}
                  autoComplete="off"
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.keyCode === 13) {
                      e.preventDefault();
                      passwordRef.current?.focus();
                    }
                  }}
                />
              </div>

              {/* Password Input with Eye Toggle */}
              <div className="input-wrapper">
                <input
                  ref={passwordRef}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password*"
                  className="custom-input"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                  autoComplete="off"
                />
                <span
                  className="password-toggle-icon"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* Login Button */}
              <button
                className="login-btn rbdButton"
                onClick={handleLogin}
                disabled={!isFormValid || loading}
                style={{
                  cursor: !isFormValid || loading ? "not-allowed" : "pointer",
                  opacity: !isFormValid || loading ? 0.6 : 1,
                }}
              >
                <span className="btn-text">
                  {loading ? "Processing..." : "Login"}
                </span>
              </button>

              {/* Footer */}
              <div className="login-footer">
                <p>
                  Don't have an account?{" "}
                  <span
                    className="login-link"
                    onClick={() => navigate("/registration")}
                  >
                    Register Now!
                  </span>
                </p>
                <p>
                  Forgot Password?{" "}
                  <span className="login-link" onClick={handleForgetPass}>
                    Click Here
                  </span>
                </p>
              </div>
            </>
          ) : (
            <>
             {/* <h3>Corporate Login</h3>
             
              <input
                type="text"
                placeholder="Username"
                className="login-input"
                name="Corporate_Username"
                value={corporateFormData.Corporate_Username}
                onChange={CorporateHandleChange}
                maxLength={100}
                autoComplete="off"
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onContextMenu={(e) => e.preventDefault()} //off to right click
              />

              {/* Corporate password with same wrapper + toggle as patient *}
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="login-input"
                  autoComplete="off"
                  name="Corporate_Password"
                  value={corporateFormData.Corporate_Password}
                  onChange={CorporateHandleChange}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                />
                <span
                  className="password-toggle-icon"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button
                className="login-btn rbdButton"
                onClick={handleCorporateLogin}
                disabled={!isCorporateFormValid || loading}
                style={{
                  cursor: isCorporateFormValid ? "pointer" : "not-allowed",
                  opacity: isCorporateFormValid ? 1 : 0.6,
                }}
              >
                <span className="btn-text">{loading ? "Logging in..." : "Login"}</span>
              </button>
              <div className="login-footer">
                <p>
                  Forgot Username?{" "}
                  <span className="login-link" onClick={handleForgetUsername}>
                    Click Here
                  </span>
                </p>
              </div>*/}





{/* Show Corporate Login ONLY when corporate tab is active */}
{activeTab === "corporate" && (
  <>
    <h3>Corporate Login</h3>

    <input
      type="text"
      placeholder="Username"
      className="login-input corporate-username-input"
      name="Corporate_Username"
      value={corporateFormData.Corporate_Username}
      onChange={CorporateHandleChange}
      maxLength={100}
      autoComplete="off"
      onCopy={(e) => e.preventDefault()}
      onPaste={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
    />

    <div className="password-wrapper">
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Password"
        className="login-input"
        autoComplete="off"
        name="Corporate_Password"
        value={corporateFormData.Corporate_Password}
        onChange={CorporateHandleChange}
        onCopy={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        onCut={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
      />
      <span
        className="password-toggle-icon corporate-password-toggle"
        onClick={() => setShowPassword((prev) => !prev)}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>

    <button
      className="login-btn rbdButton"
      onClick={handleCorporateLogin}
      disabled={!isCorporateFormValid || loading}
      style={{
        cursor: isCorporateFormValid ? "pointer" : "not-allowed",
        opacity: isCorporateFormValid ? 1 : 0.6,
      }}
    >
      <span className="btn-text">
        {loading ? "Logging in..." : "Login"}
      </span>
    </button>

    <div className="login-footer">
      <p>
        Forgot Username?{" "}
        <span className="login-link" onClick={handleForgetUsername}>
          Click Here
        </span>
      </p>
    </div>
  </>
)}




















            </>
          )}
        </div>
      </div>
    </div>
  );
}
